import React from 'react';
import './Home.css';
import Mypic from '../../assets/My_Pic_portfolioo.png';
import { useTheme } from '../../context/ThemeContext';
import { FaLinkedin, FaGithub, FaWhatsapp, FaTwitter } from 'react-icons/fa';

const Home = () => {
    const theme = useTheme();
    const themeStyle = {
        background: theme ? 'rgb(29, 42, 53)' : 'rgb(252, 249, 242)',
        color: theme ? '#ffffff' : 'rgb(29, 42, 53)',
    };
    const myName = {
        color: theme ? '#ffd700' : '#d35400',
        fontFamily: "'Montserrat', sans-serif", // Modern, clean font
        fontStyle: 'italic', // Italic effect
        fontSize: '2.8rem',
        textDecoration: 'underline',
    };


    return (
        <section id="home" className="home-section" style={themeStyle}>
            <div className="home-content">
                <div className="text-content">
                    <div className="hello-wrapper">
                        <div className="hello-sticker">
                            Hello There!
                            <div className="corner top-left"></div>
                            <div className="corner top-right"></div>
                            <div className="corner bottom-left"></div>
                            <div className="corner bottom-right"></div>
                        </div>
                    </div>
                    <div className="greeting">
                        I'm <span style={myName}>Abhishek,</span><br />
                        <span>Software Engineer at Accenture.</span><br />
                        {/* <span>At Accenture.</span> */}
                    </div>

                    <div className="about">
                        I specialize in <strong>JavaScript, SQL, PLSQL and the MERN Stack,</strong> with a strong passion for learning emerging technologies. Currently working in the field of <strong>Data Engineering using Snowflake,</strong>  I focus on building efficient, scalable solutions while continuously improving both frontend and backend performance.
                    </div>


                    <div className="buttons">
                        <a href="https://drive.google.com/file/d/1ZQjKtBppuhhx-fx0dQKAwApm4_ALY9GV/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                            <button className='homebutton'>Download CV</button>
                        </a>
                        <a href="#contact">
                            <button className='homebutton'>Contact Me</button>
                        </a>
                    </div>

                    <div className="social-buttons">
                        <a href="https://www.linkedin.com/in/abhishek-kumar-1409bb211" target="_blank" rel="noopener noreferrer" className="social-button linkedin">
                            <FaLinkedin />
                        </a>
                        <a href="https://github.com/abhii1213" target="_blank" rel="noopener noreferrer" className="social-button github">
                            <FaGithub />
                        </a>
                        <a href="https://wa.me/9142497834" target="_blank" rel="noopener noreferrer" className="social-button whatsapp">
                            <FaWhatsapp />
                        </a>
                        <a href="https://twitter.com/Abhii1213" target="_blank" rel="noopener noreferrer" className="social-button twitter">
                            <FaTwitter />
                        </a>
                    </div>
                </div>

                <div className="image-content">
                    <div className="image-sticker-container">
                        <img src={Mypic} alt="Abhishek Kumar" className="profile-image" />

                        {/* Stickers */}
                        <div className="sticker sticker-react"><i className="devicon-react-original"></i></div>
                        <div className="sticker sticker-js"><i className="devicon-javascript-plain"></i></div>
                        {/* <div className="sticker sticker-python"><i className="devicon-python-plain"></i></div> */}
                        <div className="sticker sticker-java"><i className="devicon-java-plain"></i></div>
                        {/* <div className="sticker sticker-node"><i className="devicon-nodejs-plain"></i></div> */}
                        <div className="sticker sticker-sql"><i className="devicon-mysql-plain"></i></div>
                        {/* <div className="sticker sticker-git"><i className="devicon-git-plain"></i></div> */}
                        <div className="sticker sticker-snowflake">❄️</div>
                    </div>
                </div>


            </div>
        </section>
    );
};

export default Home;
